import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

export const Image = styled.img`
  width: ${props => props.width}px;
`;

export const LogoWrapper = styled.div`
  margin: 0.4rem 0;
`;
